module.exports = __webpack_public_path__ + "media/promo/promo/images/recbg-1-df7af5179b6224d05faa9b340c74531b.png";